import "./footer.scss"

const Footer = () => {
    return (
        <div className="footer">
            <a href="https://github.com/fadelm2" target="_blank" rel="noopener noreferrer">
                <span> Developer: Fadel</span>
            </a>
            <div>
                <a href="https://github.com/fadelm2/" target="_blank">
                    <img src="../../../img/github3.png" alt=""/>
                </a>

            </div>
        </div>
    );
};

export default Footer;